import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
// import { faBell } from '@fortawesome/free-solid-svg-icons';
import "../../css/course-page.css";


class Certificateinsql extends Component {
    render() {
        return (
               <div>
                  <div aria-label="breadcrumb">
               <ol class="breadcrumb">
               <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                  <li class="breadcrumb-item active" aria-current="page">Certificate course in SQL</li>
               </ol>
            </div>
            <section class="course-header sql-color" id="course-header">
               <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5  six-sigma-bkg">
                     <h1>Certificate course in <br /> SQL<br /></h1>
                     <p>(Structured Query Language) </p><br/><br/>
                     <p>Accelerate your Career. Stay Ahead of the Curve </p>
                     <br /><br/>

                     <div class="form-group">{// eslint-disable-next-line
                                            }<a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>
                       
                         <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                           data-target="#myModal"  rel="noreferrer"  onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/certificate-course-in-sql');">Download
                        brochure</button><br/><br/><br/>
                      
                     </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                     <p> Jointly Delivered by eduplusnow and Industry Expert </p>
                     <br />
                     <table class="table-highlight">
                        <tr>
                           <td> <img alt="executive2" width="" src="/assets/images/epn.svg" /></td>
                        </tr>
                     </table>
                     <br />
                  </div>
               </div>
            </section>

            <div class="course-main-contains def-z">
                <div class="card" id="Description">
                    <div class="row contanint-display">
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                            <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;30 hours <br />
                            <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>  
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;30 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp; WEEKEND BATCH</b>
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" id="Description">    
                        
                        </div>
                    </div>
                </div>
            </div>
            <section class="def-z">
                <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Role">Job Role</a></li>
                            <li><a href="#tools">Tools</a></li>
                            <li><a href="#syllabus">Syllabus</a></li>               
                            <li><a href="#Outcomes">Learning Outcomes</a></li>           
                            <li><a href="#Review">Learner Review</a></li>          
                            <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>           
                        </ul>
                </div>
            </section>
           
            <br />
            <br /><br />

            <section class="course-description" id="course-description">
            
                <div class="row">
                    <div class="col-sm-12">
                     <h3>Description</h3>
                     <p align = "justify">If you want to gain insights from data but not sure where to start, then this course is for you. This course gives you comprehensive introduction to MySQL, one of the most highly in-demand skills in the business sectors such as marketing/Sales/Management/IT/Software today.</p>
                     <p align = "justify">Whether you run your own company, or you want to build your own apps, mastering SQL is crucial to answering complex data analytics problem using insights from data. This course provides you a solid foundation in databases in a interactive way</p>
                    </div>
                </div>
                   <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 >Course Features</h3>
                            <ul class="highlight-ul" >
                                <li>In detail coverage of SQL Fundamentals.</li>
                                <li>Covers all important query & SQL Commands.</li>
                            </ul>
                        </div>
                    </div>    
                    
                       <br />
                        <div class="row">
                            <div class="col-sm-6">
                                <h5  id="Role"> Who Should Enroll? </h5>
                                <ul class="admission-ul">
                                    <li> Ideal for any freshers, programmers, software developers and testing professionals who want to learn SQL.</li>
                                    <li> It is also ideal for marketing & sales professionals who want to better understand their orgnization's data.</li>
                                </ul>
                            </div><br />
                            <div class="col-sm-6">
                                    <h5> Eligibility </h5>
                                    <ul class="admission-ul">
                                        <li> There are no pre requisites for SQL training. This course can be taken up by anyone who wants to learn SQL.</li>
                                    </ul>
                            </div>
                        </div>
            </section>
                        
            <section class="course-industry-trends bg-secondary" id="course-industry-trends">
                            <h5 id="tools">Job Roles</h5>
                            <br />
                <div class="row">
                    <div class="col-md-3 col-sm-12 job-role-text">
                        <i class="fa fa-database btn-title-sql link-icon-sql" aria-hidden="true"></i>&nbsp;SQL developer
                    </div>
                    <div class="col-md-3 col-sm-12 job-role-text">
                        <i class="fa fa-bar-chart btn-title-sql link-icon-sql" aria-hidden="true"></i>&nbsp;Data Analyst
                    </div>
                    <div class="col-md-3 col-sm-12 job-role-text">
                        <i class="fa fa-graduation-cap btn-title-sql link-icon-sql" aria-hidden="true"></i>&nbsp;Software engineer
                    </div>
                </div>
            </section>
                        
            <br /> 
            <section class="course-tools-covered" >
                <h3> Tools Covered </h3>
                <br />
                <div class="row">
                        <div class="col-md-3 col-sm-12">
                            <div class="card cards-singles" >
                            <center id="syllabus">
                                <img alt="datascience24" src="/assets/images/icons/mysql-logo.png" /> </center>
                            </div>
                        </div>
                </div>
            </section>
           
            <section class="course-syllabus" id="course-syllabus">
            <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                     <br />
                     <h3> Syllabus </h3>
                     <br />
                     <div class="syl-bg">
                     <div id="de_syllabus">
                        <div class="panel-group">
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                 href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                 <h6 class="panel-title"><i class="indicator fa fa-minus"></i>
                                  SQL Overview
                                 </h6>
                              </div>
                              <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Relational database concepts, specific products</li>
                                       <li>SQL syntax rules </li>
                                       <li>Data definition, data manipulation, and data control statements </li>
                                       <li>SQL Updating </li>
                                       <li>Getting acquainted with the course database and editor</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                 href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                 <h6 class="panel-title"><i class="indicator fa fa-minus">
                                    </i> SQL SELECT statements
                                 </h6>
                              </div>
                              <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Clauses</li>
                                       <li>  SELECT clause: columns and aliases, where expressions, order by expressions how null values behave
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                 href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                 <h6 class="panel-title"><i class="indicator fa fa-minus"></i>
                                   SQL Functions and Expressions 
                                 </h6>
                              </div>
                              <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Eliminating duplicates with DISTINCT arithmetic expressions</li>
                                       <li>Replacing null values</li>
                                       <li>Literals, concatenation, other string functions</li>
                                       <li>Numeric operations, including rounding</li>
                                       <li>Date and time functions</li>
                                       <li> Nested table expressions</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                 href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                 <h6 class="panel-title"><i class="indicator fa fa-minus">
                                    </i> SQL Updating
                                 </h6>
                              </div>
                              <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>The INSERT, UPDATE and DELETE statements</li>
                                       <li>Column constraints and defaults</li>
                                       <li> Referential integrity constraints</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                          
                        </div>
                        
                     </div>
                   
                     <div id="damldl_syllabus">
                        <div class="panel-group">
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading4" data-toggle="collapse"
                                 href="#damldl_syllabus4" aria-expanded="true" aria-controls="damldl_syllabus4">
                                 <h6 class="panel-title"><i class="indicator fa fa-minus"></i> 
                                  SQL Joins
                                 </h6>
                              </div>
                              <div id="damldl_syllabus4" class="collapse show" aria-labelledby="damldl_heading4"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>  Inner joins </li>
                                       <li> Left, right and full outer joins</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading5" data-toggle="collapse"
                                 href="#damldl_syllabus5" aria-expanded="true" aria-controls="damldl_syllabus5">
                                 <h6 class="panel-title"><i class="indicator fa fa-minus">
                                    </i> SQL Subqueries and Unions
                                 </h6>
                              </div>
                              <div id="damldl_syllabus5" class="collapse show" aria-labelledby="damldl_heading5"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li> Intersection with IN and EXISTS</li>
                                       <li>Subqueries</li>
                                       <li>Difference with NOT IN and NOT</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading6" data-toggle="collapse"
                                 href="#damldl_syllabus6" aria-expanded="true" aria-controls="damldl_heading6">
                                 <h6 class="panel-title"><i class="indicator fa fa-minus">
                                    </i> SQL Summarization
                                 </h6>
                              </div>
                              <div id="damldl_syllabus6" class="collapse show" aria-labelledby="damldl_heading6"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li> The column functions MIN, MAX, AVG, SUM and COUNT</li>
                                       <li>GROUP BY and clauses grouping in a combination with joining</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading7" data-toggle="collapse"
                                 href="#damldl_syllabus7" aria-expanded="true" aria-controls="damldl_heading7">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Miscellaneous
                                 </h6>
                              </div>
                              <div id="damldl_syllabus7" class="collapse show" aria-labelledby="damldl_heading7"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Using Built-in Functions</li>
                                       <li>Common Table Expression</li>
                                       <li id="Outcomes">Programming with T-SQL</li>
                                       <li>Implementing Error Handling</li>
                                       <li>Executing Procedures & Functions</li>
                                       <li>Window Ranking & Aggregate Functions</li>
                                       <li>Views</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        
                        </div>
                      
                     </div>
                     </div>
                     </div>
                  </div>
                
            </section>

            <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                 <div class="row">
                    <div class="col-sm-6">
                        <h3>Learning Outcomes</h3>
                        <ul class="lo-ul">
                        <li>You will Learn how to correctly structure you database.</li>
                        <li>You will Learn how to correctly structure SQL statements & clauses.</li> 
                        <li>Write Stored Procedures and Functions.</li>
                        <li>Model real-world data and generate reports using SQL.</li>
                        <li>Answer company performance or sales questions using data.</li>
                        </ul>
                        <br />
                        <h5 >Assessment </h5>
                        <ul class="lo-ul">
                        <li   id="Review">Case studies evaluations throughout the duration of the course.</li>
                        <li>Hands on assignments on real time database during course.</li>
                        <li>Final Certification Exam.</li>
                        
                        Periodic assessment and case studies evaluations by the Indian Statistical Institute,Pune (ISI)
                        and edu plus now have been built in throughout the duration of the course.
                    
                        </ul>
                    </div>
                    <div class="col-sm-6">
                        <img alt="datascience18"src="</assets/images/icons/certificate1.png" />
                        <p class="img-below-text text-center">Awarded By edu plus now 
                        </p>
                    </div>
                </div>
            </section>
            
            <section class="course-admission-process" id="course-admission-process1">
                <br />	 
               
            </section>
            <Aboutuslearners />
            <Aluminicompany />
            <section class="courses-feesm">
                <section class="course-fees" id="course-fees">
                <div class="row box-sh" >
                <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
            
                    </div>
                        <div class="vertical-line-fee"> </div>
                        <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                            <div class="row">
                                <div class="col-sm-10"> <br /><br />
                                    <h5>Features</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                Eduplusnow's SQL Training Course Will Master you in
                                <ul class="highlight-ss" >
                                <li>Relational Database Concepts.</li>
                                <li>SQL Functions and Expressions.</li>
                                <li>SQL Joins.</li>
                                <li>SQL Summarization.</li>
                                <li>Executing Procedures & Functions.</li>
                                <li>Programming With T-SQL.</li>
                                <li>Window Ranking & Aggregate Functions.</li>
                                </ul>
                                </div>
                                <p>{// eslint-disable-next-line
                                            }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."
                                            <a href="tel://8956167195 "> &nbsp;&nbsp;
                                    <i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                            </p>   
                                <p align = "justify" class="font-text-alumni" >
                                    <span>*</span>Alumni of Eduplusnow, VIT, VIIT, VU Will Get Special Discount, To Grab your Discount coupon Please Contact  &nbsp; <a href="tel://8956167195" class="contact-us-mobile"> <i class="fa fa-phone icon-tick"> </i>+918956167195. </a><br /></p>

                            </div> 
                        </div>
                    </div>
                </section> 
            </section> 

            <Whyedu /> 
                   
            <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                <div class="row">
                    <div class="col-sm-12">
                    <h3>
                    About the Organization
                    </h3>
                    <br />
                    <img alt="datascience23"width="200px" src="/assets/images/eduplusnow.png" />
                    <br /><br />
                    <p align="justify">edu plus now is an online educational platform that was launched in 2019 to bridge the skill gap between classroom learning, real business challenges and to help students achieve their career potential.
                    </p>
                    <br />
                    <p align="justify">Aimed at providing learners with essential technical skills, edu plus now courses are created to be the perfect amalgamation of inputs from industry experts and highly-qualified professors from the country’s top educational institutions. This allows individuals and companies to close the skill gap quickly, innovate faster and achieve their key objectives. At edu plus now, we believe in preparing students for success in a changing world by providing online courses that pave the path for a successful career. Built under the aegis of the Vishwakarma Group, the online education platform provides flexible learning that fits a learner’s schedule. 
                    </p>
                    </div>
                </div>
            </section>
            <section >
                
             
            </section>
            <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                <div class="modal-dialog modal-md">
              
                    <div class="modal-content">
                        <div class="modal-header" >
                            <span class="close" id="close_form"
                               data-dismiss="modal">&times;</span>
                            <br />
                        </div>
                        <div class="modal-body">
                            <div class="panel panel-default paper-shadow box_detail">
                                <h5 class="text-center "> Download The Course Brochure </h5>
                                <form method="post" class="form-row"  onsubmit="return validate()">
                                    <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                        required="" autocomplete="on" name="name" id="name" />
                                    <b>Your email</b><input class="form-control" type="email" required=""
                                        autocomplete="on" name="emaill" id="emaill" />
                                    <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                        type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                    <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                    <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                    <br />
                                    <div>
                                        <div class="form-group">
                                            <div id="recaptcha" class="g-recaptcha"
                                                data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                            <div id="captcha"></div>
                                        </div>
                                    </div>
            
                                    <div class="mob_cb">
                                        <div>
                                        </div>
                                        <br />
                                        
                                        <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button>
                                    </div>
                                   <br />
                                </form>
                            </div>
                        </div>
                   </div>
                </div>
             </div>


            </div>
        );
    }
}

export default Certificateinsql;